import { createAction } from 'typesafe-actions';

export const setLastPanoramaPlace = createAction(
    '@result/SET_LAST_PANORAMA_PLACE',
    (payload) => payload
)();
export const resetLastPanoramaPlace = createAction('@battle/RESET_LAST_PANORAMA_PLACE')();
